import { Attribute } from "@/models/attribute";
import ApiService from "@/services/api/api.service";
import AttributeEndpoints from "@/services/attribute/attribute.endpoint";
import { AttributeSchema, BulkUpsertAttributeRequest } from "./attribute.api.types";

export class AttributeService {
  static async getAttributes(workspaceId: string, detail = false): Promise<Attribute[]> {
    const url = AttributeEndpoints.GET_ATTRIBUTES(workspaceId, detail);

    const response = await ApiService.fetchData<never, AttributeSchema[]>({
      url,
      method: "GET",
    });

    return response.data.map((schema) => new Attribute(schema.name, schema.type, schema.values));
  }

  static async bulkUpsertAttributes(workspaceId: string, attributes: Attribute[]) {
    await ApiService.fetchData<BulkUpsertAttributeRequest, void>({
      url: AttributeEndpoints.BULK_UPSERT,
      method: "POST",
      data: {
        workspaceId: workspaceId,
        definitions: attributes.map((attr) => ({
          name: attr.name,
          type: attr.type,
        })),
      },
    });
  }
}
